<template>
  <div class="guide">
    <img
      @click="handleNext"
      class="guide"
      :src="hqGuideStep1"
      alt="报表中心功能说明1"
      v-show="guideStep === 1"/>
    <img
      @click="handleKnow"
      class="guide"
      :src="hqGuideStep2"
      alt="报表中心功能说明2"
      v-show="guideStep === 2"/>
  </div>
</template>

<script>
  import hqGuideStep1 from '@assets/images/hq-guide-step-1.png';
  import hqGuideStep2 from '@assets/images/hq-guide-step-2.png';
  import cookie from 'js-cookie';

  export default {
    props: ['userInfo'],
    data (){
      return {
        hqGuideStep1,
        hqGuideStep2,
        guideStep: 1
      };
    },
    methods: {
      handleNext () {
        this.guideStep = 2;
      },
      handleKnow () {
        let hasShowReportGuideIds = cookie.get('hasShowReportGuideIds');
        if (hasShowReportGuideIds) {
          hasShowReportGuideIds = JSON.parse(hasShowReportGuideIds);
        } else {
          hasShowReportGuideIds = [];
        }
        hasShowReportGuideIds.push(this.userInfo.userId);
        cookie.set('hasShowReportGuideIds', hasShowReportGuideIds, {expires: 3650});
        location.href = '/report-web';
      }
    }
  };
</script>

<style lang="less">
  .guide {
    position: absolute;
    z-index: 3;
    width: 100%;
    bottom: 0;
    top: 0;
  }
</style>



// WEBPACK FOOTER //
// Guide.vue?9291d996